import * as types from '../actions/actionTypes';
import serverApi from '../serverApi';
import { asyncActionCreator } from './asyncActionCreatorFactory';

export function fetchLicence() {
    return asyncActionCreator(types.APP_LICENCE_UPDATED, serverApi.fetchLicence(),
    json => json);
};


// WEBPACK FOOTER //
// ./src/js/actions/licenceActionCreators.js